import VueRouter from 'vue-router';
import Vue from 'vue';
import routes from './routes';
import routeNames from '../util/routeNames';
import store from '../store/store';
import roles from '../util/roles';

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// TODO: This should absolutely not be here.
function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      store.dispatch('login', data);
      //store.dispatch('getOrg', data.attributes['custom:organization']);
      return data;
    }
  }).catch((e) => {
    console.log('Error with currentAuthenticatedUser: ', e);
    store.dispatch('logout');
    return null;
  });
}

// TODO: I hate this - fix it.
router.beforeResolve(async (to, from, next) => {
  //if the pages is refreshed and a user is not currently defined, we need to check if one exists
  const user = await getUser();

  //if we have a user, we shouldn't allow the auth path, we're already logged in
  if (user && to.fullPath === routeNames.AUTH.PATH) {
    //check to see if we are an admin or we are a normal user and segment
    if (store.getters.getUserRole === roles.ADMIN) {
      return next({
        path: routeNames.ADMIN.PATH
      });
    } else {
      return next({
        path: routeNames.ADDFAMILY.PATH
      });
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      return next({
        path: routeNames.AUTH.PATH
      });
    }

    //make sure our role mathes our auth
    if (!to.meta.role) {
      return next();
    }

    if (store.getters.getUserRole === to.meta.role) {
      return next();
    }

    console.error('The user is trying to access a route that is not allowed');
    return next({
      path: routeNames.PROFILE.PATH
    });
  }

  return next();
});

export default router
